/**
 * TableTbody.jsx
 *
 * @Author: apple
 * @Date: 2018/3/8 16:34
 */

import React from 'react';
import classNames from 'classnames';
import TableCell from './TableCell';
import Tr from './Tr';
import { isFunction } from '../util/isType';
import listenCssRender from '../util/listenCssRender';

/**
 * @ignore
 * */
class TableTbody extends React.Component {
    static propTypes = {};

    static defaultProps = {};

    constructor(props, context) {
        super(props, context);
        this.state = {
            showID: {}
        };
        this.handleExpandRowClick = this.handleExpandRowClick.bind(this);
    }

    shouldComponentUpdate(nextProps, nextState) {
        const { data, renderColumns } = this.props;
        const { data: nextData, renderColumns: nextRenderColumns } = nextProps;
        const { showID } = this.state;
        const { showID: nextShowID } = nextState;
        return data !== nextData || renderColumns !== nextRenderColumns || JSON.stringify(showID) !== JSON.stringify(nextShowID);
    }

    getTableTbody = el => {
        const { tableTbodyRef } = this.props;
        this.tableTbody = el;
        tableTbodyRef && tableTbodyRef(el);
    };

    action = (at, data, srcData, pid, id) => {
        pid = pid || "root";
        if (JSON.stringify(srcData) === "{}") {
            data[pid] = {};
            data[pid][id] = {};
        } else {
            for(var i in srcData) {
                if (i == pid && at === 'add') {
                    data[pid] = {};
                    data[pid][id] = {};
                }
                if (i == id && at === 'delete') {
                    delete data[id];
                    delete srcData[id];
                }
                if (JSON.stringify(srcData[i]) !== "{}") this.action(at, data[i], srcData[i], pid, id);
            }
        }
    }

    handleExpandRowClick(type, id, pid) {
        pid = pid || "root";
        const { showID } = this.state;
        const data = JSON.parse(JSON.stringify(showID));
        if (type === 'right-arrow') {
            this.action("add", data, JSON.parse(JSON.stringify(showID)), pid, id);
        } else if (type === 'down-arrow') {
            this.action("delete", data, JSON.parse(JSON.stringify(showID)), pid, id);
        }
        this.setState({
            showID: data
        })
    };

    renderData = (data, level, dis, pid) => {
        const mine = this;
        const {
            expandRowIds,
            renderColumns,
            selfPrefixCls,
            stripe,
            rowHeightArray,
            position,
            rules,
            pubsubEventString,
            expandOpt,
            children,
            checkbox,
            hover,
            mainDataSource,
        } = this.props;
        const extended = 0;
        return data.map((elm, i) => {
            const result = [];
            const expandRow = expandRowIds.filter(item => item === i)[0];
            const colSpan = renderColumns.length;
            const rowIndex = i + extended + 1;
            const classStr = classNames({
                [`${selfPrefixCls}-cell-stripe`]:
                    stripe && !(expandRow === 0 || expandRow) && !!(rowIndex && !(rowIndex % 2)),
            });
            const trStyle = {
                height: rowHeightArray[i],
                expandRowHeight: null,
            };
            if (expandRow) {
                trStyle.height = rowHeightArray[2 * i];
                trStyle.expandRowHeight = rowHeightArray[2 * i + 1];
            }
            if (level === 0) dis = false;
            if (JSON.stringify(mine.state.showID).indexOf(pid) > -1) dis = false;
            const trProps = {
                key: i,
                id: i,
                data: position !== 'main' ? mainDataSource[i] : elm,
                classStr,
                elm,
                rules,
                trStyle,
                renderColumns,
                position,
                selfPrefixCls,
                colSpan,
                pubsubEventString,
                expandOpt,
                children,
                checkbox,
                hover,
                level,
                handleExpandRowClick: mine.handleExpandRowClick,
                dis,
                pid
            };
            if (!dis) result.push(<Tr {...trProps} />);
            if (elm.children) {
                level ++;
                dis = true;
                if (JSON.stringify(mine.state.showID).indexOf(elm.id) > -1) dis = false;
                if (!dis) result.push(this.renderData(elm.children, level, dis, elm.id));
                level --;
            }
            return result;
        });
    }

    render() {
        const {
            tbodyClassName,
            data,
            renderColumns,
            position,
            noDataRender,
        } = this.props;
        return (
            <tbody className={tbodyClassName} ref={this.getTableTbody}>
                {data.length !== 0
                    ? this.renderData(data, 0)
                    : position === 'main' && (
                          <tr>
                              <TableCell
                                  className="text-center"
                                  colSpan={renderColumns.length}
                                  style={{ padding: '55px', color: '#999' }}
                                  content={isFunction(noDataRender) ? noDataRender() : noDataRender}/>
                          </tr>
                      )}
            </tbody>
        );
    }
}

export default TableTbody;



// WEBPACK FOOTER //
// ./src/table/TableTbody.jsx